import React, { useEffect, useRef } from "react"
import { ThemeProvider } from "styled-components"

import useFormTracking from "hooks/useFormTracking"
import useEmailSubscription from "hooks/useEmailSubscription"
import componentThemeExtension from "utils/componentThemeExtension"

import { Container, Title, Body, Details, SignUpForm } from "./styles"

const SignUpRightRail = ({
  title,
  subtitle,
  cta,
  confirmationTitle,
  confirmationSubtitle,
  mailingList,
  mailingListSource,
  segmentTrackingId,
  onSubscribe,
}) => {
  const { trackEmailFormView } = useFormTracking()
  const ref = useRef(null)

  trackEmailFormView(ref, segmentTrackingId, {
    signup_source: mailingListSource,
    list: mailingList,
  })

  const [subscribing, subscribed, error, subscribeEmail] = useEmailSubscription(segmentTrackingId)

  useEffect(() => {
    if (subscribed && onSubscribe) {
      onSubscribe()
    }
  }, [subscribed, onSubscribe])

  return (
    <Container data-exp-id="right-rail-email" ref={ref}>
      <Title>{title}</Title>
      <Body>
        <Details dangerouslySetInnerHTML={{ __html: subtitle }} />
        <ThemeProvider theme={componentThemeExtension("White", false, false)}>
          <SignUpForm
            ctaText={cta}
            requiredFields={["Email"]}
            emailPlaceholder="Enter email address"
            onSubmit={(formData) =>
              subscribeEmail(formData.email, mailingList, mailingListSource, {})
            }
            submitting={subscribing}
            submitted={
              subscribed
                ? `
                    <div>
                      <b>${confirmationTitle}</b>
                      <i>${confirmationSubtitle}</i>
                    </div>
                  `
                : null
            }
            hasError={error}
          />
        </ThemeProvider>
      </Body>
    </Container>
  )
}

export default SignUpRightRail
